export default "__VITE_ASSET__BYxT014v__"